module.exports = __webpack_public_path__ + "assets/images/electoral-college/icons/allotment-of-electors.svg?v=7c540dcf";